import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_SHRINK: GlameraIconDefinition = {
  name: 'shrink',
  viewBox: '0 0 24 24',
  svg: `
    <path class="glm-shrink-corner glm-shrink-corner-tl" d="M9 4.2V9m0 0H4.2M9 9 3 3"></path>
    <path class="glm-shrink-corner glm-shrink-corner-tr" d="M15 4.2V9m0 0h4.8M15 9l6-6"></path>
    <path class="glm-shrink-corner glm-shrink-corner-bl" d="M9 19.8V15m0 0H4.2M9 15l-6 6"></path>
    <path class="glm-shrink-corner glm-shrink-corner-br" d="m15 15 6 6m-6-6v4.8m0-4.8h4.8"></path>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-shrink-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './shrink.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class ShrinkIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_SHRINK;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
